import gql from 'graphql-tag';

// mutations

const createSession = gql`
  mutation($input: CreateSessionInput!) {
    createSession(input: $input) {
      id
      owner
      judging
      judgingRequired
      competition
      apparatus
      access
      gender
      endAt
      name
      status
      type
      startAt
      access
      sessionKey
      createdAt
      updatedAt
      producer
      _version
      sessionTeams(sortDirection: ASC) {
        items {
          id
          teamId
          order
          _version
          sessionId
        }
      }
    }
  }
`;

const updateSession = gql`
  mutation UpdateSession(
    $input: UpdateSessionInput!
    $condition: ModelSessionConditionInput
  ) {
    updateSession(input: $input, condition: $condition) {
      id
      owner
      judging
      judgingRequired
      competition
      apparatus
      gender
      access
      endAt
      name
      status
      type
      startAt
      access
      sessionKey
      createdAt
      updatedAt
      producer
      _version
      lineups {
        items {
          id
          teamId
          sessionId
          sessionTeamId
          order
          routines {
            items {
              id
              sessionId
              clips {
                items {
                  id
                  startTime
                  endTime
                  duration
                  fileName
                  originURL
                  routineId
                  streamId
                  owner
                  _version
                }
              }
              athleteId
              apparatus
              order
              rotation
              lineupId
              _version
            }
          }
        }
      }
      sessionJudges {
        items {
          id
          sessionId
          userId
          _version
        }
      }
      sessionTeams(sortDirection: ASC) {
        items {
          id
          teamId
          order
          _version
          sessionId
        }
      }
      streams(filter: { status: { ne: DELETED } }) {
        items {
          id
          streamId
          ingestURL
          outputURL
          index
          sessionId
          meta
          stats
          error
          status
          _version
        }
      }
    }
  }
`;

const getSession = gql`
  query SessionByKey($sessionKey: String!) {
    SessionByKey(sessionKey: $sessionKey) {
      items {
        id
        judging
        judgingRequired
        competition
        apparatus
        access
        endAt
        owner
        name
        status
        type
        gender
        startAt
        access
        sessionKey
        producer
        lineups {
          items {
            id
            teamId
            sessionId
            sessionTeamId
            title
            _version
            updatedAt
            createdAt
            lineupData
            order
            routines {
              items {
                id
                sessionId
                scores {
                  items {
                    id
                    routineId
                    createdAt
                    value
                    type
                    _version
                    owner
                    updatedAt
                  }
                }
                clips {
                  items {
                    id
                    startTime
                    endTime
                    duration
                    fileName
                    originURL
                    routineId
                    streamId
                    owner
                    _version
                  }
                }
                athleteId
                apparatus
                order
                rotation
                lineupId
                _version
              }
            }
          }
        }
        sessionJudges {
          items {
            id
            sessionId
            userId
            _version
          }
        }
        sessionTeams(sortDirection: ASC) {
          items {
            id
            teamId
            order
            _version
            sessionId
            team {
              id
              name
              slug
              location
              altNames
              gender
              colors
              type
              logos
              _version
              _lastChangedAt
              createdAt
              updatedAt
              owner
              coaches {
                items {
                  id
                  user {
                    id
                    name
                  }
                }
              }
              leagues {
                items {
                  id
                }
              }
              sessions {
                items {
                  id
                }
              }
              rosters(sortDirection: DESC) {
                items {
                  id
                  title
                  teamId
                  activeDate
                  archived
                  _version
                  updatedAt
                  createdAt
                  athletes {
                    items {
                      id
                      _version
                      rosterId
                      athleteId
                      classYear
                      position
                      active
                      athlete {
                        id
                        name
                        profileImg
                      }
                    }
                  }
                }
              }
            }
          }
        }
        streams(filter: { status: { ne: DELETED } }) {
          items {
            id
            streamId
            _version
            status
            vodURL
            recordingURL
            meta
            vodMeta
            recordingMeta
            ingestURL
            outputURL
            tempOutputURL
            sessionKey
            sessionId
            index
            stats
            updatedAt
          }
        }
        judges
        admins
        producers
        coaches
        _version
      }
    }
  }
`;

const checkJoinSession = gql`
  query SessionByKey($sessionKey: String!) {
    SessionByKey(sessionKey: $sessionKey) {
      items {
        id
      }
    }
  }
`;

const getSessions = gql`
  query ListSessions(
    $filter: ModelSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSessions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        sessionKey
        name
        type
        gender
        judging
        judgingRequired
        competition
        apparatus
        access
        startAt
        endAt
        status
        createdAt
        updatedAt
        _version
        _lastChangedAt
        owner
        producer
        judges
        admins
        producers
        coaches
        streams {
          items {
            id
            streamId
            _version
            status
            vodURL
            recordingURL
            meta
            vodMeta
            recordingMeta
            ingestURL
            outputURL
            tempOutputURL
            sessionKey
            sessionId
            index
            stats
            updatedAt
          }
        }
        sessionTeams(sortDirection: ASC) {
          items {
            id
            teamId
            order
            _version
            sessionId
          }
        }
        sessionJudges {
          items {
            id
            sessionId
            userId
            _version
          }
        }
        lineups {
          items {
            id
            teamId
            sessionId
            sessionTeamId
            routines {
              items {
                id
                sessionId
                clips {
                  items {
                    id
                    startTime
                    endTime
                    duration
                    fileName
                    originURL
                    routineId
                    streamId
                    owner
                    _version
                  }
                }
                athleteId
                apparatus
                order
                rotation
                lineupId
                _version
              }
            }
          }
        }
      }
    }
  }
`;

const getAthletes = gql`
  query ListAthletes(
    $filter: ModelAthleteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAthletes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        gender
        name
        firstName
        lastName
        birthday
        homeTown
        slug
        altNames
        country
        colors
        type
        profileImg
        teamAffiliations
        rosters {
          items {
            id
          }
        }
        _version
        createdAt
        updatedAt
        owner
      }
      nextToken
      startedAt
    }
  }
`;

const getLeagues = gql`
  query ListLeagues(
    $filter: ModelLeagueFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLeagues(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        slug
        type
        gender
        colors
        altNames
        logos
        _version
        teams {
          items {
            id
          }
        }
        createdAt
        updatedAt
        owner
      }
    }
  }
`;

const getTeams = gql`
  query ListTeams(
    $filter: ModelTeamFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTeams(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        slug
        location
        altNames
        gender
        colors
        type
        logos
        _version
        createdAt
        updatedAt
        owner
        lineups {
          items {
            id
          }
        }
        coaches {
          items {
            id
            user {
              id
              name
            }
          }
        }
        leagues {
          items {
            id
          }
        }
        sessions {
          items {
            id
          }
        }
        rosters(sortDirection: DESC) {
          items {
            id
            title
            teamId
            activeDate
            archived
            _version
            updatedAt
            createdAt
            athletes {
              items {
                id
                _version
                rosterId
                athleteId
                classYear
                position
                active
              }
            }
          }
        }
      }
    }
  }
`;

const getUsers = gql`
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        status
        name
        updatedAt
        createdAt
        coach {
          items {
            id
          }
        }
        judgeType
        judgeSessions {
          items {
            id
          }
        }
        firstName
        lastName
        location
        handle
        profileImg
        _version
      }
    }
  }
`;

const createLeague = /* GraphQL */ `
  mutation CreateLeague(
    $input: CreateLeagueInput!
    $condition: ModelLeagueConditionInput
  ) {
    createLeague(input: $input, condition: $condition) {
      id
      name
      altNames
      colors
      logos
      slug
      type
      gender
      logos
      _version
      createdAt
      updatedAt
      owner
    }
  }
`;

const updateLeague = `
  mutation UpdateLeague(
    $input: UpdateLeagueInput!
    $condition: ModelLeagueConditionInput
  ) {
    updateLeague(input: $input, condition: $condition) {
      id
      name
      altNames
      slug
      colors
      logos
      teams {
        items {
          id
          leagueId
          teamId
          _version
          createdAt
          updatedAt
          owner
        }
      }
      type
      gender
      createdAt
      updatedAt
      _version
      owner
    }
  }
`;

const createAthlete = `
  mutation CreateAthlete(
    $input: CreateAthleteInput!
    $condition: ModelAthleteConditionInput
  ) {
    createAthlete(input: $input, condition: $condition) {
      id
      rosters {
        items {
          id
        }
      }
      teamAffiliations
      userId
      gender
      name
      firstName
      lastName
      birthday
      homeTown
      country
      profileImg
      altNames
      colors
      slug
      type
      _version
      createdAt
      updatedAt
      owner
    }
  }
`;

const updateAthlete = `
  mutation UpdateAthlete(
    $input: UpdateAthleteInput!
    $condition: ModelAthleteConditionInput
  ) {
    updateAthlete(input: $input, condition: $condition) {
      id
      rosters {
        items {
          id
        }
      }
      teamAffiliations
      userId
      gender
      name
      firstName
      lastName
      birthday
      homeTown
      country
      profileImg
      altNames
      slug
      type
      colors
      _version
      createdAt
      updatedAt
      owner
    }
  }
`;

const createTeam = `
  mutation CreateTeam(
      $input: CreateTeamInput!
      $condition: ModelTeamConditionInput
    ) {
      createTeam(input: $input, condition: $condition) {
        id
        name
        slug
        location
        altNames
        gender
        colors
        type
        logos
        _version
        _deleted
        createdAt
        updatedAt
        owner
      }
    }
`;

const updateTeam = `
  mutation UpdateTeam(
    $input: UpdateTeamInput!
    $condition: ModelTeamConditionInput
  ) {
    updateTeam(input: $input, condition: $condition) {
      id
      name
      slug
      location
      altNames
      gender
      colors
      type
      logos
      _version
      _deleted
      createdAt
      updatedAt
      owner
    }
  }
`;

const syncSessionById = `
  subscription syncSession($id: ID!) {
    subscribeToSession(id: $id) {
      name
      status
      producer
      streams (
        filter: {
          status: {
            ne: DELETED
          }
        }
      ) {
        items {
          id
          streamId
          ingestURL
          outputURL
          index
          sessionId
          meta
          stats
          error
          status
          _version
        }
      }
      _version
    }
  }
`;

const syncStreamById = `
  subscription syncStream($id: ID!) {
    subscribeToStream(id: $id) {
      status
      _version
    }
  }  
`;

const syncSubScore = `
  subscription onUpdateSubScore($owner: String!) {
    onUpdateSubScore(owner: $owner) {
      id
    }
  }
`;

const syncNewStreamBySession = `
  subscription subscribeToNewStream($sessionId: ID!) {
    subscribeToNewStream(sessionId: $sessionId) {
      id
      streamId
      ingestURL
      outputURL
      session { 
        id
      }
      sessionId
      index
      sessionKey
      meta
      stats
      error
      status
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
    }
  }
`;

const createUser = `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      email
      status
      athlete {
        id
      }
      coach {
        items {
          id
          teamId
          userId
          _version
          _deleted
          _lastChangedAt
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      judgeType
      judgeSessions {
        items {
          id
        }
      }
      createdAt
      updatedAt
      name
      firstName
      lastName
      location
      handle
      profileImg
      _version
      owner
    }
  }
`;

const createRoster = `
  mutation CreateRoster(
    $input: CreateRosterInput!
    $condition: ModelRosterConditionInput
  ) {
    createRoster(input: $input, condition: $condition) {
      id
      teamId
      athletes {
        items {
          id
        }
      }
      activeDate
      archived
      title
      updatedAt
      createdAt
      _version
      owner
    }
  }
`;

const updateRoster = `
  mutation UpdateRoster(
    $input: UpdateRosterInput!
    $condition: ModelRosterConditionInput
  ) {
    updateRoster(input: $input, condition: $condition) {
      id
      teamId
      athletes {
        items {
          id
        }
      }
      activeDate
      archived
      title
      updatedAt
      createdAt
      _version
      owner
    }
  }
`;

const batchCreateRosterLinks = `
  mutation BatchCreateRosterLinks($rosterLinks: [CreateRosterLinkInput]) {
    batchCreateRosterLinks(rosterLinks: $rosterLinks) {
      id
      roster {
        id
      }
      rosterId
      athlete {
        id
      }
      athleteId
      classYear
      position
      active
      _version
      createdAt
      updatedAt
      owner
    }
  }
`;

const createRosterLink = `
  mutation CreateRosterLink(
    $input: CreateRosterLinkInput!
    $condition: ModelRosterLinkConditionInput
  ) {
    createRosterLink(input: $input, condition: $condition) {
      id
      rosterId
      athleteId
      classYear
      position
      active
      _version
      createdAt
      updatedAt
      owner
    }
  }

`;

const updateRosterLink = `
  mutation UpdateRosterLink(
    $input: UpdateRosterLinkInput!
    $condition: ModelRosterLinkConditionInput
  ) {
    updateRosterLink(input: $input, condition: $condition) {
      id
      rosterId
      athleteId
      classYear
      position
      active
      _version
      createdAt
      updatedAt
      owner
    }
  }
`;

const createSessionTeam = `
  mutation CreateSessionTeam(
    $input: CreateSessionTeamInput!
    $condition: ModelSessionTeamConditionInput
  ) {
    createSessionTeam(input: $input, condition: $condition) {
      id
      sessionId
      teamId
      order
      _version
    }
  }
`;

const updateSessionTeam = `
  mutation UpdateSessionTeam(
    $input: UpdateSessionTeamInput!
    $condition: ModelSessionTeamConditionInput
  ) {
    updateSessionTeam(input: $input, condition: $condition) {
            id
      sessionId
      teamId
      order
      _version
    }
  }
`;

const userByEmail = `
  query UserByEmail(
    $email: AWSEmail
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    UserByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        status
        athleteId
        coach {
          items { 
            id
            _version
          }
        }
        judgeType
        judgeSessions {
          items {
            id
            _version

          }
        }
        createdAt
        updatedAt
        name
        firstName
        lastName
        location
        handle
        profileImg
        googleId
        facebookId
        appleId
        cognitoId
        _version
      }
    }
  }
`;

const createLineup = `
  mutation CreateLineup(
    $input: CreateLineupInput!
    $condition: ModelLineupConditionInput
  ) {
    createLineup(input: $input, condition: $condition) {
      id
      teamId
      sessionId
      sessionTeamId
      routines {
        items {
          id
        }
      }
      title
      updatedAt
      createdAt
      lineupData
      order
      _version
    }
  }
`;

const updateLineup = `
  mutation UpdateLineup(
    $input: UpdateLineupInput!
    $condition: ModelLineupConditionInput
  ) {
    updateLineup(input: $input, condition: $condition) {
      id
      teamId
      sessionId
      sessionTeamId
      order
      routines {
        items {
          id
          sessionId
          athleteId
          apparatus
          order
          rotation
          lineupId
          _version
          createdAt
          updatedAt
        }
        nextToken
        startedAt
      }
      title
      updatedAt
      createdAt
      lineupData
      _version
    }
  }
`;

const updateStream = `
  mutation UpdateStream(
    $input: UpdateStreamInput!
    $condition: ModelStreamConditionInput
  ) {
    updateStream(input: $input, condition: $condition) {
      id
      streamId
      _version
      status
      vodURL
      recordingURL
      meta
      vodMeta
      recordingMeta
      ingestURL
      outputURL
      tempOutputURL
      sessionKey
      sessionId
      index
      stats
      updatedAt
    }
  }
`;

const syncLineupById = `
  subscription syncLineup($id: ID!) {
    subscribeToLineup(id: $id) {
      id
      teamId
      sessionId
      sessionTeamId
      order
      routines {
        items {
          id
          sessionId
          athleteId
          apparatus
          order
          rotation
          lineupId
          _version
          createdAt
          updatedAt
        }
        nextToken
        startedAt
      }
      title
      updatedAt
      createdAt
      lineupData
      _version
    }
  }  
`;

const updateUser = `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      email
      status
      athleteId
      coach {
        items { 
          id
          _version
        }
      }
      judgeType
      judgeSessions {
        items {
          id
          _version

        }
      }
      createdAt
      updatedAt
      name
      firstName
      lastName
      location
      handle
      profileImg
      googleId
      facebookId
      appleId
      cognitoId
      _version
    }
  }
`;

const createRoutineGQL = `
  mutation CreateRoutine(
    $input: CreateRoutineInput!
    $condition: ModelRoutineConditionInput
  ) {
    createRoutine(input: $input, condition: $condition) {
      id
      sessionId
      athleteId
      apparatus
      order
      rotation
      lineupId
      status
      score
      _version
      createdAt
      updatedAt
    }
  }
`;

const updateRoutineGQL = `
  mutation UpdateRoutine(
    $input: UpdateRoutineInput!
    $condition: ModelRoutineConditionInput
  ) {
    updateRoutine(input: $input, condition: $condition) {
      id
      sessionId
      clips {
        items {
          id          
        }
      }
      athleteId
      apparatus
      order
      rotation
      lineupId
      status
      score
      scores {
        items {
          id
          routineId
          createdAt
          value
          type
          _version
          updatedAt
          owner
        }
      }
      _version
      createdAt
      updatedAt
      owner
    }
  }
`;

const createScoreGQL = `
  mutation CreateScore(
    $input: CreateScoreInput!
    $condition: ModelScoreConditionInput
  ) {
    createScore(input: $input, condition: $condition) {
      id
      routineId
      createdAt
      value
      type
      _version
      updatedAt
    }
  }
`;

const updateScoreGQL = `
  mutation UpdateScore(
    $input: UpdateScoreInput!
    $condition: ModelScoreConditionInput
  ) {
    updateScore(input: $input, condition: $condition) {
      id
      routineId
      createdAt
      value
      type
      _version
      updatedAt
    }
  }
`;

const createClipGQL = `
    mutation CreateClip(
    $input: CreateClipInput!
    $condition: ModelClipConditionInput
  ) {
    createClip(input: $input, condition: $condition) {
      id
      startTime
      endTime
      pgmStartTime
      pgmEndTime
      duration
      fileName
      originURL
      routineId
      _version
      createdAt
      updatedAt
      streamId
      owner
    }
  }
`;


const updateClipGQL = `
  mutation UpdateClip(
    $input: UpdateClipInput!
    $condition: ModelClipConditionInput
  ) {
    updateClip(input: $input, condition: $condition) {
      id
      startTime
      endTime
      pgmStartTime
      pgmEndTime
      duration
      fileName
      originURL
      routineId
      _version
      createdAt
      updatedAt
      streamId
      owner
    }
  }
`;

const syncScoreById = `
  subscription subscribeToScore($id: ID!) {
    subscribeToScore(id: $id) {
      id
      routineId
      createdAt
      value
      type
      _version
      updatedAt
      owner
    }
  }
`;

const syncNewScoresByRoutine = `
  subscription subscribeToNewScore($routineId: ID!) {
    subscribeToNewScore(routineId: $routineId) {
      id
      routineId
      createdAt
      value
      type
      _version
      _deleted
      _lastChangedAt
      updatedAt
      owner
    }
  }
`;

const syncRoutineById = `
  subscription subscribeToRoutine($id: ID!) {
    subscribeToRoutine(id: $id) {
      id
      sessionId
      clips {
        items {
          id
          startTime
          endTime
          pgmStartTime
          pgmEndTime
          duration
          fileName
          originURL
          routineId
          _version
          createdAt
          updatedAt
          streamId
          owner
        }
        nextToken
        startedAt
      }
      athleteId
      apparatus
      order
      rotation
      lineupId
      status
      score
      scores {
        items {
          id
          routineId
          createdAt
          value
          type
          _version
          updatedAt
          owner
        }
        startedAt
      }
      _version
      createdAt
      updatedAt
      owner
    }
  }
`;

const syncNewRoutinesByLineup = `
  subscription subscribeToNewRoutine($lineupId: ID!) {
    subscribeToNewRoutine {
      id
      sessionId
      clips {
        items {
          id
          startTime
          endTime
          pgmStartTime
          pgmEndTime
          duration
          fileName
          originURL
          routineId
          _version
          createdAt
          updatedAt
          streamId
          owner
        }
        startedAt
      }
      athleteId
      apparatus
      order
      rotation
      lineupId
      status
      score
      scores {
        items {
          id
          routineId
          createdAt
          value
          type
          _version
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      _version
      createdAt
      updatedAt
      owner
    }
  }
`;

const syncClipById = `
  subscription subscribeToClip($id: ID!) {
    subscribeToClip(id: $id) {
      id
      startTime
      endTime
      pgmStartTime
      pgmEndTime
      duration
      fileName
      originURL
      routineId
      _version
      createdAt
      updatedAt
      streamId
      owner
    }
  }
`;

const syncNewClipsByRoutine = `
  subscription subscribeToNewClip($routineId: ID!) {
    subscribeToNewClip(routineId: $routineId) {
      id
      startTime
      endTime
      pgmStartTime
      pgmEndTime
      duration
      fileName
      originURL
      routineId
      _version
      createdAt
      updatedAt
      streamId
      owner
    }
  }
`;

export {
  createSession,
  updateSession,
  getSession,
  getSessions,
  getAthletes,
  createUser,
  getUsers,
  getTeams,
  getLeagues,
  createLeague,
  updateLeague,
  updateTeam,
  createTeam,
  syncSessionById,
  syncSubScore,
  syncStreamById,
  syncNewStreamBySession,
  createAthlete,
  updateAthlete,
  createRoster,
  updateRoster,
  batchCreateRosterLinks,
  createRosterLink,
  updateRosterLink,
  createSessionTeam,
  updateSessionTeam,
  userByEmail,
  createLineup,
  updateLineup,
  checkJoinSession,
  updateStream,
  syncLineupById,
  updateUser,
  createRoutineGQL,
  createClipGQL,
  createScoreGQL,
  updateRoutineGQL,
  updateClipGQL,
  updateScoreGQL,
  syncScoreById,
  syncNewScoresByRoutine,
  syncRoutineById,
  syncNewRoutinesByLineup,
  syncClipById,
  syncNewClipsByRoutine,
};
